/**
 * Phone number validation & E.164 formatting.
 *
 * Shopify's Admin API requires phone numbers in E.164 format:
 *   +<country-dial-code><subscriber-number>
 *   e.g. +41791234567  (max 15 digits total)
 *
 * This module:
 *  1. Maps ISO 3166-1 alpha-2 country codes → dial codes
 *  2. Validates that a phone number has the right length for the country
 *  3. Normalises to E.164
 *  4. Wires up live & submit-time validation on <input> elements
 */

/* Inject phone-validation styles once */
(function() {
  if (document.getElementById('phone-validation-styles')) return;
  var style = document.createElement('style');
  style.id = 'phone-validation-styles';
  style.textContent = [
    '.phone-validation-error { display: block; color: #cc0000; font-size: 1.2rem; margin-top: 0.4rem; min-height: 0; }',
    '.field--phone-error .field__input { border-color: #cc0000; }',
  ].join('\n');
  document.head.appendChild(style);
})();

window.PhoneValidation = (function () {
  'use strict';

  /* ── country-code → dial-code & digit-range map ────────────────────── */
  const COUNTRY_PHONE = {
    AF: { dial: '93',  min: 9,  max: 9  },
    AL: { dial: '355', min: 9,  max: 9  },
    DZ: { dial: '213', min: 9,  max: 9  },
    AD: { dial: '376', min: 6,  max: 9  },
    AO: { dial: '244', min: 9,  max: 9  },
    AR: { dial: '54',  min: 10, max: 11 },
    AM: { dial: '374', min: 8,  max: 8  },
    AU: { dial: '61',  min: 9,  max: 9  },
    AT: { dial: '43',  min: 4,  max: 13 },
    AZ: { dial: '994', min: 9,  max: 9  },
    BH: { dial: '973', min: 8,  max: 8  },
    BD: { dial: '880', min: 10, max: 10 },
    BY: { dial: '375', min: 9,  max: 10 },
    BE: { dial: '32',  min: 8,  max: 9  },
    BA: { dial: '387', min: 8,  max: 8  },
    BR: { dial: '55',  min: 10, max: 11 },
    BG: { dial: '359', min: 8,  max: 9  },
    CA: { dial: '1',   min: 10, max: 10 },
    CL: { dial: '56',  min: 9,  max: 9  },
    CN: { dial: '86',  min: 11, max: 11 },
    CO: { dial: '57',  min: 10, max: 10 },
    HR: { dial: '385', min: 8,  max: 9  },
    CY: { dial: '357', min: 8,  max: 8  },
    CZ: { dial: '420', min: 9,  max: 9  },
    DK: { dial: '45',  min: 8,  max: 8  },
    EG: { dial: '20',  min: 10, max: 10 },
    EE: { dial: '372', min: 7,  max: 8  },
    FI: { dial: '358', min: 5,  max: 12 },
    FR: { dial: '33',  min: 9,  max: 9  },
    DE: { dial: '49',  min: 3,  max: 13 },
    GR: { dial: '30',  min: 10, max: 10 },
    HK: { dial: '852', min: 8,  max: 8  },
    HU: { dial: '36',  min: 8,  max: 9  },
    IS: { dial: '354', min: 7,  max: 7  },
    IN: { dial: '91',  min: 10, max: 10 },
    ID: { dial: '62',  min: 9,  max: 12 },
    IE: { dial: '353', min: 7,  max: 9  },
    IL: { dial: '972', min: 9,  max: 9  },
    IT: { dial: '39',  min: 6,  max: 11 },
    JP: { dial: '81',  min: 9,  max: 10 },
    KZ: { dial: '7',   min: 10, max: 10 },
    KE: { dial: '254', min: 9,  max: 9  },
    KR: { dial: '82',  min: 9,  max: 10 },
    KW: { dial: '965', min: 8,  max: 8  },
    LV: { dial: '371', min: 8,  max: 8  },
    LB: { dial: '961', min: 7,  max: 8  },
    LI: { dial: '423', min: 7,  max: 7  },
    LT: { dial: '370', min: 8,  max: 8  },
    LU: { dial: '352', min: 4,  max: 11 },
    MY: { dial: '60',  min: 9,  max: 10 },
    MT: { dial: '356', min: 8,  max: 8  },
    MX: { dial: '52',  min: 10, max: 10 },
    MD: { dial: '373', min: 8,  max: 8  },
    MC: { dial: '377', min: 8,  max: 8  },
    ME: { dial: '382', min: 8,  max: 8  },
    MA: { dial: '212', min: 9,  max: 9  },
    NL: { dial: '31',  min: 9,  max: 9  },
    NZ: { dial: '64',  min: 8,  max: 10 },
    NG: { dial: '234', min: 10, max: 10 },
    NO: { dial: '47',  min: 8,  max: 8  },
    PK: { dial: '92',  min: 10, max: 10 },
    PH: { dial: '63',  min: 10, max: 10 },
    PL: { dial: '48',  min: 9,  max: 9  },
    PT: { dial: '351', min: 9,  max: 9  },
    QA: { dial: '974', min: 8,  max: 8  },
    RO: { dial: '40',  min: 9,  max: 9  },
    RU: { dial: '7',   min: 10, max: 10 },
    SA: { dial: '966', min: 9,  max: 9  },
    RS: { dial: '381', min: 8,  max: 9  },
    SG: { dial: '65',  min: 8,  max: 8  },
    SK: { dial: '421', min: 9,  max: 9  },
    SI: { dial: '386', min: 8,  max: 8  },
    ZA: { dial: '27',  min: 9,  max: 9  },
    ES: { dial: '34',  min: 9,  max: 9  },
    SE: { dial: '46',  min: 7,  max: 13 },
    CH: { dial: '41',  min: 9,  max: 9  },
    TW: { dial: '886', min: 9,  max: 9  },
    TH: { dial: '66',  min: 9,  max: 9  },
    TR: { dial: '90',  min: 10, max: 10 },
    UA: { dial: '380', min: 9,  max: 9  },
    AE: { dial: '971', min: 9,  max: 9  },
    GB: { dial: '44',  min: 10, max: 10 },
    US: { dial: '1',   min: 10, max: 10 },
    VN: { dial: '84',  min: 9,  max: 10 },
  };

  /* Fallback for countries not in the map */
  const DEFAULT_RANGE = { min: 4, max: 14 };

  /**
   * Strip everything except digits from a string.
   */
  function digitsOnly(value) {
    return (value || '').replace(/\D/g, '');
  }

  /**
   * Get dial code and digit range for an ISO alpha-2 country code.
   */
  function getCountryInfo(countryCode) {
    return COUNTRY_PHONE[(countryCode || '').toUpperCase()] || null;
  }

  /**
   * Normalise a user-entered phone number to E.164.
   *
   * Accepts formats like:
   *   079 123 45 67   → +41791234567
   *   0791234567      → +41791234567
   *   +41 79 123 45 67 → +41791234567
   *   791234567       → +41791234567
   *
   * @param {string} phone   - Raw user input
   * @param {string} country - ISO alpha-2 country code (e.g. "CH")
   * @returns {string|null}  - E.164 string or null if it cannot be normalised
   */
  function toE164(phone, country) {
    if (!phone) return null;

    const info = getCountryInfo(country);
    if (!info) return null;

    let digits = digitsOnly(phone);
    if (!digits) return null;

    // If the number already starts with the dial code, don't double-prefix
    if (digits.startsWith(info.dial)) {
      // Already has the dial code — just prefix with +
      return '+' + digits;
    }

    // Strip leading zero (national trunk prefix)
    if (digits.startsWith('0')) {
      digits = digits.substring(1);
    }

    return '+' + info.dial + digits;
  }

  /**
   * Validate a phone number for the given country.
   *
   * @param {string} phone   - Raw user input
   * @param {string} country - ISO alpha-2 country code
   * @returns {{ valid: boolean, message: string, e164: string|null }}
   */
  function validate(phone, country) {
    if (!phone || !phone.trim()) {
      return { valid: true, message: '', e164: null }; // empty is OK (field may be optional)
    }

    // Only allow digits, spaces, dashes, parentheses, dots and leading +
    if (!/^[+\d\s\-().]+$/.test(phone.trim())) {
      return {
        valid: false,
        message: 'Phone number contains invalid characters.',
        e164: null,
      };
    }

    const info = getCountryInfo(country);
    const range = info || DEFAULT_RANGE;

    let digits = digitsOnly(phone);

    // If it starts with the dial code, strip it to get the subscriber part
    if (info && digits.startsWith(info.dial)) {
      digits = digits.substring(info.dial.length);
    } else if (digits.startsWith('0')) {
      digits = digits.substring(1);
    }

    if (digits.length < range.min) {
      return {
        valid: false,
        message: `Phone number is too short (minimum ${range.min} digits).`,
        e164: null,
      };
    }

    if (digits.length > range.max) {
      return {
        valid: false,
        message: `Phone number is too long (maximum ${range.max} digits).`,
        e164: null,
      };
    }

    const e164 = info ? ('+' + info.dial + digits) : null;

    // E.164 total max is 15 digits
    if (e164 && digitsOnly(e164).length > 15) {
      return {
        valid: false,
        message: 'Phone number exceeds the maximum allowed length.',
        e164: null,
      };
    }

    return { valid: true, message: '', e164: e164 };
  }

  /**
   * Attach live validation to phone input fields.
   *
   * @param {Object} opts
   * @param {HTMLInputElement} opts.phoneInput   - The phone <input>
   * @param {HTMLSelectElement} opts.countrySelect - The country <select>
   * @param {boolean}          [opts.required]    - Treat empty as invalid?
   */
  function attachValidation({ phoneInput, countrySelect, required }) {
    if (!phoneInput) return;

    // Create an error message element below the input's parent .field wrapper
    var errorEl = document.createElement('span');
    errorEl.className = 'phone-validation-error';
    errorEl.setAttribute('aria-live', 'polite');
    var fieldWrapper = phoneInput.closest('.field') || phoneInput.parentElement;
    fieldWrapper.parentElement.insertBefore(errorEl, fieldWrapper.nextSibling);

    function runValidation() {
      var phone = phoneInput.value;
      var country = countrySelect ? countrySelect.value : '';

      if (!phone.trim()) {
        phoneInput.setCustomValidity(required ? 'Phone number is required.' : '');
        errorEl.textContent = '';
        fieldWrapper.classList.remove('field--phone-error');
        return;
      }

      var result = validate(phone, country);
      phoneInput.setCustomValidity(result.valid ? '' : result.message);

      if (result.valid) {
        errorEl.textContent = '';
        fieldWrapper.classList.remove('field--phone-error');
      } else {
        errorEl.textContent = result.message;
        fieldWrapper.classList.add('field--phone-error');
      }
    }

    phoneInput.addEventListener('input', runValidation);
    phoneInput.addEventListener('blur', runValidation);
    if (countrySelect) {
      countrySelect.addEventListener('change', runValidation);
    }

    // Run once on attach to validate pre-filled values
    runValidation();
  }

  /* ── public API ────────────────────────────────────────────────────── */
  return {
    validate: validate,
    toE164: toE164,
    digitsOnly: digitsOnly,
    getCountryInfo: getCountryInfo,
    attachValidation: attachValidation,
  };
})();
